module.exports = __webpack_public_path__ + "img/couples-030.f6d803f8.jpg";